import { getCategory } from "../lib/categories";

interface CategoryChipProps {
  categoria: string;
  size?: "sm" | "md";
}

/** Badge de categoría con punto de color, usado en cards de foro/biblioteca */
export function CategoryChip({ categoria, size = "md" }: CategoryChipProps) {
  const cat = getCategory(categoria);
  const fontSize = size === "sm" ? "0.72rem" : "0.8rem";
  const padding = size === "sm" ? "4px 10px" : "5px 13px";
  return (
    <span className="badge" style={{ background: cat.bg, color: cat.text, fontSize, padding }}>
      <span className="badge__dot" style={{ background: cat.dot }} />
      {cat.label}
    </span>
  );
}

interface CategoryDotLabelProps {
  categoria: string;
}

/** Punto + label simple, usado en listas de filtros laterales */
export function CategoryDotLabel({ categoria }: CategoryDotLabelProps) {
  const cat = getCategory(categoria);
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 9 }}>
      <span style={{ width: 9, height: 9, borderRadius: "50%", background: cat.dot, flexShrink: 0 }} />
      {cat.label}
    </span>
  );
}
